import cx from 'classnames'
import React from 'react'
import { Field } from 'redux-form'

import FilterRadioParent from '@cinch/oxd-components/filter-radio-parent/src/filter-radio-parent.component'
import FilterRadio from '@cinch/oxd-components/filter-radio/src'

import BackLinkComponent from './components/back-link.component'

import * as styles from './filter-make-model.module.css'

interface MMConfig {
  label: string
  key: string
  options: Array<{ label: string; value: string }>
}

interface MakeModelProps {
  makeConfig: MMConfig
  modelConfig: MMConfig
  selectedMake?: string
  onResetMake: () => void
}

const FilterPlainRadio = (props: any) => <FilterRadio hideRadio={true} {...props} />

const FiltersMakeModel: React.FC<MakeModelProps> = ({ makeConfig, modelConfig, selectedMake, onResetMake }) => {
  const classNames = cx([
    styles.makeModel,
    {
      [styles.makeSelected]: !!selectedMake,
    },
  ])

  const resetMakeClicked = (event: any) => {
    if (event) {
      event.preventDefault()
    }
    if (selectedMake) {
      onResetMake()
    }
  }

  const scrollToTopIfMakeSelected = (elem: any) => {
    if (selectedMake && elem) {
      elem.scrollTop = 0
    }
  }

  return (
    <div className={classNames} ref={scrollToTopIfMakeSelected}>
      <div className={styles.contents}>
        <div className={styles.makes} role="radiogroup">
          {makeConfig.options.map((option) => {
            return (
              <Field type="radio" key={option.value} name={makeConfig.key} {...option} component={FilterRadioParent} />
            )
          })}
        </div>
        <div className={styles.models} role={selectedMake ? 'radiogroup' : ''}>
          {!!selectedMake && (
            <>
              <BackLinkComponent onClick={resetMakeClicked}>{selectedMake}</BackLinkComponent>
              <Field type="radio" value="" label="Any" name={modelConfig.key} component={FilterPlainRadio} />
              {modelConfig.options.map((option) => {
                return (
                  <Field
                    type="radio"
                    key={option.value}
                    name={modelConfig.key}
                    {...option}
                    component={FilterPlainRadio}
                  />
                )
              })}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default FiltersMakeModel
